import { AuthStateService } from './../../../services/auth-state.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AdminComponent } from '../../../pages/admin/admin.component';
import { BreadcrumbService } from '../../../services/breadcrumb.service';
import { Router } from '@angular/router';
import { BillingService } from '../../../services/billing.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {

  private userNameSubscription: Subscription;
  private breadcrumbSubscription: Subscription;
  public userName: string = null;
  public items: MenuItem[];
  public sysMode: string | null = null;

  constructor(
    public app: AdminComponent,
    private auth: AuthStateService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    public billing: BillingService,
  ) {
    this.breadcrumbSubscription = this.breadcrumbService.itemsHandler.subscribe(response => {
      this.items = response;
    });
    this.userNameSubscription = this.auth.userName$.subscribe(userName => this.userName = userName);
  }

  ngOnInit(): void {
    this.sysMode = this.auth.getSysMode();
  }

  ngOnDestroy(): void {
    if (this.breadcrumbSubscription) {
      this.breadcrumbSubscription.unsubscribe();
    }
    if (this.userNameSubscription) {
      this.userNameSubscription.unsubscribe();
    }
  }

  public logout(): void {
    this.auth.logout();
  }


  public hasAvailabilities(): boolean {
    return (
      this.auth.hasRole('moderator') ||
      this.auth.hasRole('moderator_external') ||
      this.auth.hasRole('observer') ||
      this.auth.hasRole('observer_gem')
    );
  }

  public gotoProfile(): void {
    this.router.navigate(['/my-profile']);
  }

  public gotoAvailabilities(): void {
    this.router.navigate(['/my-availabilities']);
  }

  public gotoNewOrder(): void {
    this.router.navigate(['/planning/orderform']);
  }

  public gotoFreeOrder(): void {
    this.router.navigate(['/planning/orders/new']);
  }

}
